import config from '../../config'
import { buildGetQuery } from '../../util'

import { IGetRequestObject, ISafetyReportQuestion } from '../../interfaces'

const request = (): IGetRequestObject => {
  return {
    method: 'get',
    url: `${config.baseUrl}/sms/SafetyReportQuestions/active`,
  }
}

const useSafetyReportActiveQuestions = buildGetQuery<undefined, undefined, ISafetyReportQuestion[] | undefined>({
  getRequest: request,
  getQueryKey: () => ['safety-report-active-questions'],
})

export default useSafetyReportActiveQuestions
